import endsWith from 'lodash/endsWith';
import startsWith from 'lodash/startsWith';
import { ClientItem } from 'owa-mail-store';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import {
    MULTIPART_SIGNED_CONTENT_TYPE,
    PKCS_MIME_TYPE,
    SMIME_FILE_EXTENSION,
    X_PKCS_MIME_TYPE,
} from './constants';

export const getFirstAttachment = (item: ClientItem): AttachmentType =>
    item && item.Attachments && item.Attachments.length && item.Attachments[0];

/**
 * Used for Encrypted and Opaque signed scenario
 */
export const hasPKCSContentType = (attachment: AttachmentType): boolean =>
    attachment.ContentType &&
    (startsWith(attachment.ContentType, X_PKCS_MIME_TYPE) ||
        startsWith(attachment.ContentType, PKCS_MIME_TYPE));

/**
 *
 * Used for clearSigned scenario
 */
export const hasSignedContentType = (attachment: AttachmentType): boolean =>
    attachment.ContentType && attachment.ContentType === MULTIPART_SIGNED_CONTENT_TYPE;
/**
 *
 * @param item An SMIME item
 * Returns the AttachmentType from the attachments of an item that contains the p7m attachment info.
 * For an S/MIME message, there should only be one attachment with a *.p7m Name (Unless decoded on server)
 * pkcs7 syntax is used to digitally sign, digest, authenticate, or encrypt arbitrary message content and
 * should be indicated in the contentType.
 */
export const getSmimeAttachmentType = (item: ClientItem): AttachmentType => {
    const smimeAttachmentType = getFirstAttachment(item);
    if (
        smimeAttachmentType &&
        smimeAttachmentType.Name &&
        endsWith(smimeAttachmentType.Name, SMIME_FILE_EXTENSION) &&
        (hasPKCSContentType(smimeAttachmentType) || hasSignedContentType(smimeAttachmentType))
    ) {
        return smimeAttachmentType;
    }
    return null;
};

export default getSmimeAttachmentType;
